import { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import { useTheme } from "styled-components";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import useLogoutModal from "../MenuSelector/useLogoutModal";

import MenuItem from "../MenuSelector/MenuItem";

import { LogButton, LoginButton, MenuContainer } from "./styles";

import Basket from "components/IconImage/basket";
import { cartState } from "state/cart-slice";
import { configState } from "state/config-slice";
import { userState } from "state/user-slice";
import ThemeInterface from "types/ThemeInterface";

interface IMenuSelector {
  isCartVisible?: boolean;
  isLogButtonsVisible?: boolean;
}

const MenuSelector: FunctionComponent<IMenuSelector> = ({ isCartVisible, isLogButtonsVisible }) => {
  const currentCart = useSelector(cartState);
  const appTheme: ThemeInterface = useTheme();
  const activePath = useLocation().pathname;
  const { t } = useTranslation();
  const userInfo = useSelector(userState);
  const config = useSelector(configState);
  const url = config.openidUrls?.find((el) => el.type === "bronze" || el.type === "gold")?.url;
  const { openLogoutModal } = useLogoutModal();

  return (
    <MenuContainer>
      {isLogButtonsVisible && userInfo.loggedIn && (
        <LogButton data-testid="log-out-btn" title={t("Log Out")} onClick={openLogoutModal} />
      )}
      {isLogButtonsVisible && !userInfo.loggedIn && (
        <LoginButton data-testid="log-in-btn" href={url}>
          {t("Log In")}
        </LoginButton>
      )}
      {isCartVisible && (
        <MenuItem
          data-testid="basket-btn"
          icon={<Basket stroke={appTheme.customTheme.palette.black.standard} />}
          label="Basket"
          isActive={activePath === "/basket"}
          link={"/basket"}
          notificationsAmount={currentCart.cart.length}
        />
      )}
    </MenuContainer>
  );
};

export default MenuSelector;
